import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useImageSearchStore } from '@/store/imageSearchStore';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

// 评论数据配置
const COMMENTS = [
  `Fuck, that asshole actually leaked our photos online. I'm so pissed, but at least I found this tool to track them down. - Ma**e R.`,
  `I searched for myself and my family, and honestly, it was gut-wrenching to see how our privacy is just being spread everywhere. - Fa**y T.`,
  `Tinder is full of scammers! Thank god this tool helped me catch that person who's been stealing photos left and right. - Sa**e D.`,
  `I can't believe it, there's literally an account out there just stealing my stuff. That's so messed up! - St**n C.`,
  `I never thought my photos would be leaked to so many places. This tool really opened my eyes. - Pr**y M.`,
  `I honestly ran the search just to be safe. Finding my photos already out there was not what I expected. - Rae K.***.`,
];

// 单个评论卡片
function CommentCard({ text }: { text: string }) {
  const { t } = useTranslation();
  return (
    <div className={styles.commentCard}>
      <img src="/images/Content-Monitoring/quote-img.png" alt="" className={styles.quoteDecoration} />
      <div className={styles.thumbIcon}>
        <img src="/images/Content-Monitoring/thumb-icon.png" alt="thumbs up" />
      </div>
      <p className={styles.commentText}>{t(text)}</p>
    </div>
  );
}

export default function ImageSearchComment() {
  const { open, isPinned, setOpen } = useImageSearchStore();
  const placeholderRef = useRef<HTMLDivElement>(null);
  const mainRef = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(false);
  // 记录 main 元素的高度，用于占位
  const mainHeightRef = useRef(0);

  // 组件挂载后测量高度
  useLayoutEffect(() => {
    if (mainRef.current) {
      mainHeightRef.current = mainRef.current.offsetHeight;
    }
  });

  useEffect(() => {
    if (!isPinned || !open) return;

    const handleScroll = () => {
      if (!placeholderRef.current || !mainRef.current) return;

      // 使用 placeholder 或 main 的位置来判断
      // 当 placeholder 高度为 0 时，用 main 的位置；否则用 placeholder 的位置
      const rect = isFixed ? placeholderRef.current.getBoundingClientRect() : mainRef.current.getBoundingClientRect();

      setIsFixed(rect.top <= 0);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isPinned, open, isFixed]);

  if (!open) return null;

  // PC端：前3条和后3条交替
  const pcGroup1 = [COMMENTS[0], COMMENTS[1], COMMENTS[2]];
  const pcGroup2 = [COMMENTS[3], COMMENTS[4], COMMENTS[5]];

  // 移动端：6条循环
  const mobileComments = [...COMMENTS, COMMENTS[0]];

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        ref={placeholderRef}
        className={styles.placeholder}
        style={{ height: isPinned && isFixed ? mainHeightRef.current : 0 }}
      />
      <div ref={mainRef} className={`${styles.main} ${isPinned && isFixed ? styles.fixed : ''}`}>
        <div className={styles.container}>
          {/* 关闭按钮 -- 只有置顶的时候显示 */}
          {isPinned && (
            <div className={styles.closeBtnIcon} onClick={handleClose}>
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.353516 0.351562L6.35352 6.35156M12.3535 12.3516L6.35352 6.35156M6.35352 6.35156L12.3535 0.351562L0.353516 12.3516"
                  stroke="#02183A"
                />
              </svg>
            </div>
          )}

          {/* PC端：3个卡片槽位，每个槽位内2张卡片滚动 */}
          <div className={styles.pcCards}>
            {[0, 1, 2].map((slotIndex) => (
              <div key={slotIndex} className={styles.cardSlot}>
                <div className={styles.scrollTrackPC}>
                  <CommentCard text={pcGroup1[slotIndex]} />
                  <CommentCard text={pcGroup2[slotIndex]} />
                  <CommentCard text={pcGroup1[slotIndex]} />
                </div>
              </div>
            ))}
          </div>

          {/* 移动端：1个卡片槽位，6张卡片滚动 */}
          <div className={styles.mobileCard}>
            <div className={styles.cardSlot}>
              <div className={styles.scrollTrackMobile}>
                {mobileComments.map((text, index) => (
                  <CommentCard key={index} text={text} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
